if (!customElements.get('vics-product-assurances')) {
  customElements.define('vics-product-assurances', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const {signal} = this.controller;
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-assurance-open]');
        const close = event.target.closest('[data-assurance-close]');
        if (trigger) {
          const panel = this.querySelector(`[id="${trigger.getAttribute('aria-controls')}"]`);
          if (!panel || panel.open) return;
          this.trigger = trigger;
          panel.showModal();
          panel.querySelector('[data-assurance-close]').focus({preventScroll:true});
        }
        if (close) close.closest('dialog').close();
      }, {signal});
      this.querySelectorAll('dialog').forEach(panel => {
        panel.addEventListener('close', () => {
          this.trigger?.focus({preventScroll:true});
        }, {signal});
        panel.addEventListener('click', event => {
          if (event.target !== panel) return;
          const rect = panel.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) panel.close();
        }, {signal});
      });
    }
    disconnectedCallback() {
      this.querySelectorAll('dialog[open]').forEach(panel => panel.close());
      this.controller?.abort();
      this.controller = null;
    }
  });
}

